var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99988 0.274902C4.44759 0.274902 3.99988 0.722618 3.99988 1.2749V3.2749C3.99988 3.82719 4.44759 4.2749 4.99988 4.2749C5.55216 4.2749 5.99988 3.82719 5.99988 3.2749V1.2749C5.99988 0.722618 5.55216 0.274902 4.99988 0.274902Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 0.274902C12.4476 0.274902 11.9999 0.722618 11.9999 1.2749V3.2749C11.9999 3.82719 12.4476 4.2749 12.9999 4.2749C13.5522 4.2749 13.9999 3.82719 13.9999 3.2749V1.2749C13.9999 0.722618 13.5522 0.274902 12.9999 0.274902Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7412 8.84678C11.0391 8.4708 11.5801 8.41475 11.9448 8.72832C12.3034 9.03664 12.3517 9.58299 12.0585 9.95301L9.08712 13.703C8.93054 13.9006 8.69617 14.0199 8.44419 14.0247C8.19216 14.0295 7.95349 13.9192 7.78982 13.7274L5.96126 11.5845C5.65473 11.2253 5.68454 10.6776 6.03141 10.3565C6.38418 10.0298 6.92692 10.0644 7.23849 10.4295L8.40441 11.7958L10.7412 8.84678Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99988 3.22491H2.74988C2.05952 3.22491 1.49988 3.78456 1.49988 4.47491V6.2749L16.4999 6.2749V4.47491C16.4999 3.78456 15.9402 3.22491 15.2499 3.22491H14.9999V1.72491H15.2499C16.7687 1.72491 17.9999 2.95613 17.9999 4.47491V14.9749C17.9999 16.4937 16.7687 17.7249 15.2499 17.7249H2.74988C1.23109 17.7249 -0.00012207 16.4937 -0.00012207 14.9749V4.47491C-0.00012207 2.95613 1.23109 1.72491 2.74988 1.72491H2.99988V3.22491ZM1.49988 14.9749V7.7749L16.4999 7.7749V14.9749C16.4999 15.6653 15.9402 16.2249 15.2499 16.2249H2.74988C2.05952 16.2249 1.49988 15.6653 1.49988 14.9749Z",
    fill: "#777777"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99988 3.22491H10.9999V1.72491H6.99988V3.22491Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/Attendance.7e91b062cf9e858a590787eff71f0e07.svg";
export { ForwardRef as ReactComponent };